import Vue from 'vue';
import moment from 'moment';
import _ from 'lodash';
import { store } from '@/store';

Vue.filter('getNameByID', function (id) {
  const obj = _.find(store.state.nivel, function (el) {
    return el.id === id;
  });
  return obj.nombre;
});
Vue.filter('getTestGradeID', function (testID) {
  const test = _.find(store.state.testsFromDB, function (el) {
    return el.id === testID;
  });
  return test.grade_id;
});

Vue.filter('deleteUnderscore', function (value) {
  if (!value) return '';
  return value.replace(/_/g, ' ');
});
/** Elimina los números del string */
Vue.filter('deleteNumbers', function (value) {
  // Elimina los números del string y elimina los espcios al inicio y al final del string
  if (!value) return '';
  return value.replace(/[0-9]+/g, '').trim();
});
/** Abrevia el nombre de la materia */
Vue.filter('abbreviate', function (value) {
  // Elimina los espcios al inicio y al final del string
  const valueFormatted = value.replace(/[0-9]/g, '').toLowerCase().trim();
  if (valueFormatted === 'mathematics') {
    return 'Math';
  }
  if (valueFormatted === 'grammar') {
    return 'Gram';
  }
  if (valueFormatted === 'reading') {
    return 'Rdg';
  }
  if (valueFormatted === 'science') {
    return 'Sci';
  }
  if (valueFormatted === 'social studies') {
    return 'S. Stud';
  }
  if (valueFormatted === 'american history') {
    return 'A. Hist';
  }
  if (valueFormatted === 'physics') {
    return 'Phys';
  }
  if (valueFormatted === 'world studies') {
    return 'W. Stud';
  }
  if (valueFormatted === 'biology') {
    return 'Biol';
  }
  if (valueFormatted === 'chemistry') {
    return 'Chem';
  }

  return valueFormatted;
});
/** Recibe un array de materias y retorna una fecha obtenida de la primer pregunta para mostrar en que fecha se hizo la evaluación */
Vue.filter('getDateStartOfEvaluation', function (array) {
  const evaluation = Object.values(array);
  let dateEvaluation;

  evaluation.forEach(subject => {
    // console.log(subject)
    dateEvaluation = subject[0].started_date;
  });
  // console.log(dateEvaluation)
  return moment(dateEvaluation).format('LLL');
});
/** Parsea un valor string a int */
Vue.filter('parseInt', function (value) {
  // eslint-disable-next-line radix
  return parseInt(value);
});
/** Evalua una materia que es un array de preguntas dando un porcentaje como resultado */
// FIXME: Mover la lógica del filtro al componente donde se usa.
Vue.filter('evaluateSubjectByPercentage', function (array) {
  let correctAnswers = 0;
  array.forEach(question => {
    if (question.answered_correctly) {
      correctAnswers += 1;
    }
  });
  /** Calcula el porcentaje de repuestas correctas */
  const value = (correctAnswers * 100) / _.size(array);
  return value % 1 === 0 ? value : value.toFixed(2);
});
/** Recibe un porcetaje y retorna una letra como calificación */
Vue.filter('evaluateByLetters', function (value) {
  if (value >= 94) {
    return 'A';
  }
  if (value >= 90 && value <= 94) {
    return 'A- ';
  }
  if (value >= 87 && value <= 90) {
    return 'B+ ';
  }
  if (value >= 83 && value <= 87) {
    return 'B ';
  }
  if (value >= 80 && value <= 83) {
    return 'B- ';
  }
  if (value >= 77 && value <= 80) {
    return 'C+ ';
  }
  if (value >= 73 && value <= 77) {
    return 'C ';
  }
  if (value >= 70 && value <= 73) {
    return 'C- ';
  }
  if (value >= 67 && value <= 70) {
    return 'D+ ';
  }
  if (value >= 63 && value <= 67) {
    return 'D ';
  }
  if (value >= 60 && value <= 63) {
    return 'D- ';
  }
  return 'F';
});
Vue.filter('dayAndDate', function (value) {
  return moment(value).format('dddd') + ' ' + moment(value).format('DD-MM-YYYY');
});

Vue.filter('date', function (value) {
  return moment(value).calendar();
});

Vue.filter('englishDate', function (value) {
  return moment(value).calendar();
});

Vue.filter('englishDateNew', function (value) {
  return moment(value).format('L');
});

Vue.filter('relativeTimeFromNow', function (value) {
  return moment(value).fromNow();
});

Vue.filter('relativeTimeFromNowInSS', function (value) {
  if (value === 0) {
    return 0;
  }
  return moment.utc(value * 1000).format('HH:mm:ss');
  // return moment.duration(value, 'seconds').minutes()
});

/** Recibe un argumento representado en seconds */
Vue.filter('formatDuration', function (value) {
  // return moment(moment.duration(value)._data).format('HH:mm:ss')
  return moment.utc(value * 1000).format('HH:mm:ss');
});

Vue.filter('secondsToTime', function (value) {
  // eslint-disable-next-line no-underscore-dangle
  // return moment(moment.duration(value, 'seconds')).format('HH:mm:ss');
  // return moment.duration(value, 'seconds').format('HH:mm:ss');
  return moment.utc(value * 1000).format('HH:mm:ss');
});

Vue.filter('formatDurationTest', function (value) {
  // eslint-disable-next-line no-underscore-dangle
  // return moment(moment.duration(value, 'seconds')).format('HH:mm:ss');
  // return moment.duration(value, 'seconds').format('HH:mm:ss');
  return moment.utc(value).format('HH:mm:ss');
});

Vue.filter('arrayLength', function (value) {
  if (value !== null) {
    // console.log(Object.keys(value).length)
    return Object.keys(value).length;
  }
  return 0;
});

Vue.filter('humanizeDuration', function (value) {
  // eslint-disable-next-line no-underscore-dangle
  return moment(moment.duration(value)._data).humanize();
});

Vue.filter('roundNumber', function (value) {
  if (!value) return 0;
  return Math.round(value);
});

Vue.filter('timerTime', function (s) {
  const ms = s % 1000;
  const secs = s % 60;
  const mins = s % 60;
  // Pad to 2 or 3 digits, default is 2
  function pad(n, z) {
    // eslint-disable-next-line no-param-reassign
    z = z || 2;
    // eslint-disable-next-line prefer-template
    return ('00' + n).slice(-z);
  }
  // eslint-disable-next-line no-param-reassign
  s = (s - ms) / 1000;
  // eslint-disable-next-line no-param-reassign
  s = (s - secs) / 60;
  return `${pad(mins)}:${pad(secs)}.${ms}`;
});

// eslint-disable-next-line no-unused-vars
Vue.filter('computedTime', function (value) {
  return moment.duration(0, 'minutes').format('d[d] h[h] m[m] s[s]', { trim: 'both' });
});

/**
 * Vue filter to convert the given value to percent.
 * http://jsfiddle.net/bryan_k/qauf3qyh/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.filter('percentage', function (value, decimals) {
  let newValue = value;
  let newDecimals = decimals;
  if (!value) {
    newValue = 0;
  }

  if (!decimals) {
    newDecimals = 0;
  }

  newValue = newValue.toFixed(newDecimals);
  newValue += '%';

  return newValue;
});
